export default {
    root: function (_a) {
        var props = _a.props;
        return ({
            class: [
                // Font
                {
                    'tw-text-xl': props.size == 'large',
                    'tw-text-2xl': props.size == 'xlarge',
                },
                // Flex & Alignment
                'tw-inline-flex tw-items-center tw-justify-center',
                // Position
                'tw-relative',
                // Sizes
                {
                    'tw-size-8': props.size == null || props.size == 'normal',
                    'tw-size-12': props.size == 'large',
                    'tw-size-16': props.size == 'xlarge',
                },
                // Shapes
                {
                    'tw-rounded-lg': props.shape == 'square',
                    'tw-rounded-full': props.shape == 'circle',
                },
            ],
        });
    },
    image: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-h-full tw-w-full',
                // Shapes
                {
                    'tw-rounded-lg': props.shape == 'square',
                    'tw-rounded-full': props.shape == 'circle',
                },
            ],
        });
    },
};
